import type { App, Plugin } from "vue"
import { MODEL_INJECTION_KEY, ModelLogLevel } from "@/utils/useEngineModel"
import { ModelFacade } from "@/utils/useEngineModel/ModelFacade"

export interface useEngineModelOptions {
  logLevel?: ModelLogLevel
}

/**
 * Provides a global ModelFacade instance. Must call `initialise` after auth0
 * authenicates.
 */
const plugin: Plugin = {
  install: (app: App, options: useEngineModelOptions) => {
    const logLevel = options?.logLevel ? options.logLevel : ModelLogLevel.Off
    const model = new ModelFacade(logLevel)

    app.provide(MODEL_INJECTION_KEY, model)
  },
}

export default plugin
